import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type JSX,
  type ReactNode,
} from 'react';

interface SidebarUIContextValue {
  isMobileOpen: boolean;
  openMobileSidebar: () => void;
  closeMobileSidebar: () => void;
}

const SidebarUIContext = createContext<SidebarUIContextValue | null>(null);

export function SidebarUIProvider({ children }: { children: ReactNode }): JSX.Element {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const openMobileSidebar = useCallback(() => setIsMobileOpen(true), []);
  const closeMobileSidebar = useCallback(() => setIsMobileOpen(false), []);
  const value = useMemo(
    () => ({ isMobileOpen, openMobileSidebar, closeMobileSidebar }),
    [isMobileOpen, openMobileSidebar, closeMobileSidebar],
  );
  return <SidebarUIContext.Provider value={value}>{children}</SidebarUIContext.Provider>;
}

export function useSidebarUI(): SidebarUIContextValue {
  const ctx = useContext(SidebarUIContext);
  if (!ctx) {
    throw new Error('useSidebarUI must be used within a SidebarUIProvider');
  }
  return ctx;
}
